
export default function WhistlerOverview() {
  const keyPoints = [
    {
      icon: 'ri-map-pin-line',
      title: 'Tourist Accommodation Zoning',
      description:
        'Whistler uses a unique TA (Tourist Accommodation) zoning designation. Only properties in TA zones can legally operate as short-term rentals.'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Business License Required',
      description:
        'All STR operators must obtain a Resort Municipality of Whistler business license and register with the provincial STR registry.'
    },
    {
      icon: 'ri-time-line',
      title: 'No Night Limits in TA Zones',
      description:
        'Unlike other BC municipalities, properties in TA zones have no annual night restrictions and can operate year-round as full-time rentals.'
    },
    {
      icon: 'ri-home-heart-line',
      title: 'Residential Zone Restrictions',
      description:
        'Properties in residential zones face strict limitations. Principal residence requirements and night caps may apply outside TA areas.'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="inline-block bg-[#882629]/10 text-[#882629] px-4 py-2 rounded-full text-sm font-medium mb-4">
            Regulatory Overview
          </span>
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            Understanding Whistler&apos;s STR Framework
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            As a resort municipality, Whistler has developed a unique regulatory framework that balances tourism accommodation needs with community housing concerns. The key is understanding which zone your property falls under.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {keyPoints.map((point) => (
            <div
              key={point.title}
              className="bg-[#F8F8F8] rounded-2xl p-8 hover:shadow-lg transition-all"
            >
              <div className="w-14 h-14 bg-[#882629]/10 rounded-xl flex items-center justify-center mb-6">
                <i className={`${point.icon} text-2xl text-[#882629]`}></i>
              </div>
              <h3 className="text-xl font-semibold text-[#505A5A] mb-3">{point.title}</h3>
              <p className="text-[#505A5A]/70 leading-relaxed">{point.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-[#882629]/5 to-[#882629]/10 rounded-2xl p-8 lg:p-12">
          <div className="grid lg:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-[#882629] mb-2">$350</div>
              <p className="text-[#505A5A]/70">Annual License Fee</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#882629] mb-2">3M+</div>
              <p className="text-[#505A5A]/70">Annual Visitors</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#882629] mb-2">$1,000+</div>
              <p className="text-[#505A5A]/70">Daily Violation Penalties</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
